<footer class="govbook-footer">
  <div class="govbook-footer__pre-footer">
    <div class="govuk-width-container">
      <div class="row">
        <div class="col-sm-12 col-md-5 footer-col-logo">
          <img src="assets/images/cambridgeshirecc-logo-white.svg" alt="Cambridgeshire County Council" class="logo">
        </div>

        <div class="col-sm-6 col-md-3">
          <nav aria-labelledby="footer-heading-legal" class="footer-column">
            <h2 class="visually-hidden" id="footer-heading-legal">Legal</h2>
            <ul class="menu menu--footer">
              <li class="menu-item">
                <a target="_blank" aria-label="Privacy statement (opens in new window)"
                  rel="noopener noreferrer" class="footer-links"
                  href="https://www.cambridgeshire.gov.uk/council/data-protection-and-foi/information-and-data-sharing/privacy-statement">Privacy statement</a>
              </li>
              <li class="menu-item">
                <a target="_blank"
                  aria-label="Registration service privacy notice (opens in new window)"
                  rel="noopener noreferrer" class="footer-links"
                  href="https://www.cambridgeshire.gov.uk/council/data-protection-and-foi/information-and-data-sharing/privacy-statement/registration-service-privacy-notice">Registration service privacy notice</a>
              </li>
              <li class="menu-item">
                <a target="_blank" aria-label="Terms and disclaimer (opens in new window)" class="footer-links"
                  rel="noopener noreferrer"
                  href="https://www.cambridgeshire.gov.uk/terms-and-disclaimer">Terms and disclaimer</a>
              </li>
              <li class="menu-item">
                <a target="_blank" aria-label="Cookies (opens in new window)" rel="noopener noreferrer"
                  class="footer-links" href="https://www.cambridgeshire.gov.uk/council/cookies-on-our-website">Cookies
                  on our website</a>
              </li>
            </ul>
          </nav>
        </div>

        <div class="col-sm-6 col-md-4">
          <nav aria-labelledby="footer-heading-about" class="footer-column">
            <h2 class="visually-hidden" id="footer-heading-about">About this service</h2>
            <ul class="menu menu--footer">
              <li class="menu-item">
                <a target="_blank" aria-label="Contact us (opens in new window)" rel="noopener noreferrer"
                  class="footer-links" href="https://www.cambridgeshire.gov.uk/council/contact-us">Contact us</a>
              </li>
              <li class="menu-item">
                <a aria-label="Accessibility statement" class="footer-links"
                  [routerLink]="['/accessibility-statement']">Accessibility statement</a>
              </li>
              <li class="menu-item">
                <a target="_blank" aria-label="Language and translation (opens in new window)"
                  rel="noopener noreferrer" class="footer-links"
                  href="https://www.cambridgeshire.gov.uk/language-and-translation">Language and translation</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <div class="govbook-footer__footer">
    <div class="govbook-container">
      <div class="govbook-row">
        <div class="govbook-row__full">
          <div class="govbook-region govbook-region--footer region region-footer">
            <div class="govbook-container padding-horizontal">
              <div class="govbook-region__inner govbook-region__inner--footer">
                <div id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
                  class="block block-localgov-core block-localgov-powered-by-block">
                  <span>Powered by
                    <a target="_blank" aria-label="Bookinglab | GovBook (opens in new window)" class="footer-links"
                      href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=cambridgeshire
                                            ">bookinglab | GovBook</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
